if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  document.body.classList.add("safari");
}

const cartDrawer = document.getElementById("cart-drawer");
const cartDrawerSectionId = cartDrawer.getAttribute("data-section-id");
const nonaHeader = document.getElementById("header-nona");
const nonaHeaderSectionId = nonaHeader.getAttribute("data-section-id");

let busyUpdating = false;
const FREE_PRODUCT_DISCOUNT_CODE = "NONACB20";
let skipFreeProductCheck = false;
let skipFreeProductWithOtherCheck = false;

const FREE_PRODUCT_BLOCK_KEY = "freeProductBlockedUntil";
const FREE_PRODUCT_BLOCK_MS = 3 * 24 * 60 * 60 * 1000; // 3 days

const blockFreeProducts = () => {
  localStorage.setItem(
    FREE_PRODUCT_BLOCK_KEY,
    String(Date.now() + FREE_PRODUCT_BLOCK_MS),
  );
  console.log("[FreeProduct] Blocked for 3 days due to discount conflict.");
};

const isFreeProductBlocked = () => {
  const until = localStorage.getItem(FREE_PRODUCT_BLOCK_KEY);
  if (!until) return false;
  if (Date.now() < parseInt(until, 10)) return true;
  localStorage.removeItem(FREE_PRODUCT_BLOCK_KEY); // expired
  return false;
};
const replaceSection = (sectionId, content, updateId) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  document.getElementById(
    updateId || "shopify-section-" + sectionId,
  ).innerHTML = doc.getElementById(
    updateId || "shopify-section-" + sectionId,
  ).innerHTML;
};

const addToCart = async (
  button,
  variantId,
  quantity = 1,
  isFreeProduct = false,
  customProperties = {},
) => {
  // TODO
  const launchProductId = document.body.dataset.launchProductId;
  if (
    document.body.classList.contains("offer") &&
    launchProductId &&
    variantId.toString() === launchProductId
  ) {
    quantity = quantity * 2;
  }
  let originalText = "";
  // Show a loading state on the button
  if (button) {
    originalText = button.textContent;
    button.querySelector("span").textContent =
      button.getAttribute("data-adding") || "Adding...";
    button.disabled = true;
    button.classList.add("loading");
  }

  const formData = {
    items: [
      {
        id: variantId,
        quantity,
        properties: isFreeProduct
          ? { _free_product: "true", ...customProperties }
          : Object.keys(customProperties).length > 0
            ? customProperties
            : undefined,
      },
    ],
    sections: [cartDrawerSectionId, nonaHeaderSectionId],
  };

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  if (!response.ok) {
    openNonaModal(window.nona.strings.errorAddingToCart);
    console.error("Error adding to cart:", error);
    if (button) {
      button.querySelector("span").textContent = originalText;
      button.disabled = false;
      button.classList.remove("loading");
    }
    return;
  }
  const data = await response.json();
  const currentCartJson = await fetch(window.Shopify.routes.root + "cart.js");
  const currentCart = await currentCartJson.json();

  data.total_price = currentCart.total_price;
  data.items = currentCart.items;

  //

  console.log("dataa", data, currentCart);
  // toast(
  //   window.nona.strings.addedToCart.replace("XXX", data.items[0].title),
  //   "success"
  // );

  await updateCartJS(data, true);
  if (button) {
    button.querySelector("span").textContent = originalText;
    button.disabled = false;
    button.classList.remove("loading");
  }
};

const removeCartItem = async (
  lineItemId,
  quantity,
  giftbox,
  button,
  extraLineItemIds = [],
) => {
  if (busyUpdating) return;
  busyUpdating = true;

  if (button) {
    button.disabled = true;
    button.classList.add("loading");
  }

  const updates = { [lineItemId]: 0 };
  extraLineItemIds.forEach((id) => {
    updates[id] = 0;
  });

  console.log("Removing item:", lineItemId, "extras:", extraLineItemIds);

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: updates,
      sections: [cartDrawerSectionId, nonaHeaderSectionId],
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then(async (data) => {
      console.log("Item removed:", data);
      busyUpdating = false;
      if (button) {
        button.disabled = false;
        button.classList.remove("loading");
      }
      await updateCartJS(data);
    })
    .catch((error) => {
      busyUpdating = false;
      if (button) {
        button.disabled = false;
        button.classList.remove("loading");
      }
      console.error("Error:", error);
    });
};

const checkFreeProduct = async (
  threshold,
  freeProductIds,
  cartItems,
  cartTotal,
) => {
  // Always re-read from body — single source of truth.
  // Note: data-free-product2-id (no hyphen before 2) maps to dataset.freeProduct2Id.
  const ids = [
    document.body.dataset.freeProductId,
    document.body.dataset.freeProduct2Id,
  ].filter(Boolean);

  console.group("[FreeProduct] checkFreeProduct");
  console.log("  campaignIds:", ids);
  console.log("  cartTotal:", cartTotal, "| threshold:", threshold);
  console.log(
    "  busyUpdating:",
    busyUpdating,
    "| skipFreeProductCheck:",
    skipFreeProductCheck,
  );
  console.log(
    "  blockUntil:",
    localStorage.getItem(FREE_PRODUCT_BLOCK_KEY),
    "| blocked:",
    isFreeProductBlocked(),
  );
  console.log(
    "  cartItems:",
    cartItems.map((i) => ({
      key: i.key,
      variantId: i.variant_id,
      title: i.title,
      qty: i.quantity,
      finalLinePrice: i.final_line_price,
      props: i.properties,
    })),
  );

  // If a cart operation is in progress, skip — that operation will call
  // updateCartJS when it finishes, which will re-run this check with fresh data.
  if (busyUpdating) {
    console.log("  → EXIT: busy updating");
    console.groupEnd();
    return;
  }

  // Skip if a special discount was just removed and we cleared free products manually.
  if (skipFreeProductCheck) {
    console.log("  → EXIT: skipFreeProductCheck flag set — clearing flag");
    skipFreeProductCheck = false;
    console.groupEnd();
    return;
  }

  // Skip if a discount conflict was previously detected and the block is still active.
  // NOTE: we only skip re-adding below — removal of paid/stale free products still runs.
  const blocked = isFreeProductBlocked();
  if (blocked) {
    console.log(
      "  blocked by localStorage until",
      new Date(
        parseInt(localStorage.getItem(FREE_PRODUCT_BLOCK_KEY), 10),
      ).toLocaleString(),
      "— will still remove any paid free products",
    );
  }

  const allFreeProductsInCart = cartItems.filter(
    (item) => item.properties && item.properties._free_product === "true",
  );
  console.log(
    "  allFreeProductsInCart:",
    allFreeProductsInCart.map((i) => ({
      key: i.key,
      variantId: i.variant_id,
      finalLinePrice: i.final_line_price,
    })),
  );

  if (ids.length === 0) {
    console.log("  → No campaign IDs set — removing all free products in cart");
    for (const item of allFreeProductsInCart) {
      console.log(
        "    Removing (no campaign active):",
        item.variant_id,
        item.key,
      );
      await removeCartItem(item.key, 1, false, null);
    }
    console.groupEnd();
    return;
  }

  const isOverThreshold =
    parseInt(cartTotal.toString()) >= parseInt(threshold.toString());
  console.log("  isOverThreshold:", isOverThreshold);

  // Remove stale free products (variant no longer part of the campaign)
  const staleProducts = allFreeProductsInCart.filter(
    (item) => !ids.includes(item.variant_id.toString()),
  );
  console.log(
    "  staleProducts:",
    staleProducts.map((i) => ({ key: i.key, variantId: i.variant_id })),
  );
  for (const item of staleProducts) {
    console.log("  → Removing stale free product:", item.variant_id, item.key);
    await removeCartItem(item.key, 1, false, null);
  }
  if (staleProducts.length > 0) {
    console.log("  → EXIT: removed stale products — updateCartJS will re-run");
    console.groupEnd();
    return;
  }

  // Detect discount conflict: free products are in the cart but are no longer priced at €0.
  // This happens when a manual discount code (e.g. NONACB20) takes priority over the free
  // product mechanism and Shopify can't combine them.
  const paidFreeProducts = allFreeProductsInCart.filter(
    (item) => item.final_line_price > 0,
  );
  console.log(
    "  paidFreeProducts (conflict):",
    paidFreeProducts.map((i) => ({
      key: i.key,
      variantId: i.variant_id,
      finalLinePrice: i.final_line_price,
    })),
  );
  if (paidFreeProducts.length > 0) {
    console.log(
      "  → CONFLICT: free products now charged — batch-removing and blocking for 3 days",
    );
    blockFreeProducts();
    // Batch-remove all in one request to avoid busyUpdating blocking the second removal
    const updates = {};
    paidFreeProducts.forEach((item) => {
      updates[item.key] = 0;
    });
    console.log("  → Batch update payload:", updates);
    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates,
        sections: [cartDrawerSectionId, nonaHeaderSectionId],
      }),
    })
      .then((r) => r.json())
      .then((data) => updateCartJS(data));
    console.groupEnd();
    return;
  }

  // From here on: only re-adding logic. Skip if blocked.
  if (blocked) {
    console.log("  → EXIT: blocked — skipping re-add");
    console.groupEnd();
    return;
  }

  // Remove duplicate free products of each type, keep only the first
  for (const id of ids) {
    const dupes = cartItems.filter(
      (item) =>
        item.variant_id.toString() === id.toString() &&
        item.properties &&
        item.properties._free_product === "true",
    );
    console.log(`  dupes for ${id}:`, dupes.length);
    for (let i = 1; i < dupes.length; i++) {
      console.log(`  → Removing duplicate free product ${id}`, dupes[i].key);
      await removeCartItem(dupes[i].key, 1, false, null);
    }
    if (dupes.length > 1) {
      console.log("  → EXIT: removed duplicates — updateCartJS will re-run");
      console.groupEnd();
      return;
    }
  }

  if (isOverThreshold) {
    // Collect all IDs that are missing from the cart
    const missingIds = ids.filter(
      (id) =>
        !cartItems.some(
          (item) =>
            item.variant_id.toString() === id.toString() &&
            item.properties &&
            item.properties._free_product === "true",
        ),
    );
    console.log("  missingIds to add:", missingIds);

    if (missingIds.length === 0) {
      console.log("  → EXIT: all free products already in cart");
      console.groupEnd();
      return;
    }

    console.log("  → Adding missing free products:", missingIds);

    // Batch-add all missing free products in a single /cart/add.js call
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: missingIds.map((id) => ({
          id,
          quantity: 1,
          properties: { _free_product: "true" },
        })),
        sections: [cartDrawerSectionId, nonaHeaderSectionId],
      }),
    });

    if (!response.ok) {
      console.error("Failed to add free products:", await response.text());
      console.groupEnd();
      return;
    }

    // Fetch fresh cart to get accurate total and items
    const currentCartJson = await fetch(window.Shopify.routes.root + "cart.js");
    const currentCart = await currentCartJson.json();
    const data = await response.json();
    data.total_price = currentCart.total_price;
    data.items = currentCart.items;

    console.log("  → Free products added, calling updateCartJS");
    console.groupEnd();
    await updateCartJS(data, false);
  } else {
    console.log(
      "  → Under threshold — removing any free products still in cart",
    );
    // Under threshold — remove any free products still in cart
    for (const id of ids) {
      const freeInCart = cartItems.filter(
        (item) =>
          item.variant_id.toString() === id.toString() &&
          item.properties &&
          item.properties._free_product === "true",
      );
      console.log(
        `  freeInCart for ${id}:`,
        freeInCart.map((i) => i.key),
      );
      for (const item of freeInCart) {
        console.log(
          `  → Removing free product ${id} (under threshold)`,
          item.key,
        );
        await removeCartItem(item.key, 1, false, null);
      }
      if (freeInCart.length > 0) {
        console.groupEnd();
        return;
      }
    }
    console.log("  → No free products to remove (under threshold)");
    console.groupEnd();
  }
};

const checkFreeProductWithOther = async (cartItems) => {
  if (skipFreeProductWithOtherCheck) {
    skipFreeProductWithOtherCheck = false;
    return;
  }

  const freeProductWithOtherId = document.body.dataset.freeProductWithOtherId;
  const needsToBeBoughtId = document.body.dataset.freeProductNeedsToBeBoughtId;
  const needsToBeBoughtQuantity = parseInt(
    document.body.dataset.freeProductNeedsToBeBoughtQuantity || "1",
    10,
  );

  const withOtherInCart = cartItems.filter(
    (item) =>
      item.properties && item.properties._free_product_with_other === "true",
  );

  // If campaign is not configured, remove any lingering items
  if (!freeProductWithOtherId || !needsToBeBoughtId) {
    for (const item of withOtherInCart) {
      await removeCartItem(item.key, 1, false, null);
    }
    return;
  }

  if (busyUpdating) return;

  // Detect discount conflict: "with other" free products now charged at non-zero price
  const paidWithOther = withOtherInCart.filter(
    (item) => item.final_line_price > 0,
  );
  if (paidWithOther.length > 0) {
    const updates = {};
    paidWithOther.forEach((item) => {
      updates[item.key] = 0;
    });
    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates,
        sections: [cartDrawerSectionId, nonaHeaderSectionId],
      }),
    })
      .then((r) => r.json())
      .then((data) => updateCartJS(data));
    return;
  }

  // Check if the trigger product is in the cart (as a real item, not a free-with-other product)
  const triggerQuantityInCart = cartItems
    .filter(
      (item) =>
        item.variant_id.toString() === needsToBeBoughtId.toString() &&
        !(item.properties && item.properties._free_product_with_other === "true"),
    )
    .reduce((sum, item) => sum + item.quantity, 0);
  const triggerInCart = triggerQuantityInCart >= needsToBeBoughtQuantity;

  const freeWithOtherInCart = withOtherInCart.filter(
    (item) => item.variant_id.toString() === freeProductWithOtherId.toString(),
  );

  // Remove duplicates — keep only the first
  for (let i = 1; i < freeWithOtherInCart.length; i++) {
    await removeCartItem(freeWithOtherInCart[i].key, 1, false, null);
  }
  if (freeWithOtherInCart.length > 1) return;

  if (triggerInCart && freeWithOtherInCart.length === 0) {
    // Trigger product is in cart but free product is not yet — add it
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: freeProductWithOtherId,
            quantity: 1,
            properties: { _free_product_with_other: "true" },
          },
        ],
        sections: [cartDrawerSectionId, nonaHeaderSectionId],
      }),
    });
    if (!response.ok) {
      console.error(
        "[FreeProductWithOther] Failed to add:",
        await response.text(),
      );
      return;
    }
    const currentCartJson = await fetch(window.Shopify.routes.root + "cart.js");
    const currentCart = await currentCartJson.json();
    const data = await response.json();
    data.total_price = currentCart.total_price;
    data.items = currentCart.items;
    skipFreeProductWithOtherCheck = true;
    await updateCartJS(data, false);
  } else if (!triggerInCart && freeWithOtherInCart.length > 0) {
    // Trigger product no longer in cart — remove the free product
    for (const item of freeWithOtherInCart) {
      await removeCartItem(item.key, 1, false, null);
    }
  }
};

const refreshCartSections = async () => {
  const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates: {},
      sections: [cartDrawerSectionId, nonaHeaderSectionId],
    }),
  });
  const data = await response.json();
  await updateCartJS(data);
};

const updateCartJS = async (data, clickFromOutside = false) => {
  replaceSection(cartDrawerSectionId, data.sections[cartDrawerSectionId]);
  replaceSection(
    nonaHeaderSectionId,
    data.sections[nonaHeaderSectionId],
    "cart-icon",
  );

  setupHeaderFunctionality(true);
  if (clickFromOutside) {
    setTimeout(() => {
      toggleCartDrawer();
    }, 0);
  } else {
    toggleCartDrawer();
  }
  // Reset button state
  hookUpAmountChangeListeners();
  hookUpAddToCartListeners("#cart-drawer");
  hookUpDiscountFormListeners();

  console.log("data", data);

  document.dispatchEvent(
    new CustomEvent("nona:cart:updated", { detail: data }),
  );

  const threshold = document.body.dataset.threshold;
  const freeProductId = document.body.dataset.freeProductId;
  const freeProduct2Id = document.body.dataset.freeProduct2Id;
  const freeProductIds = [freeProductId, freeProduct2Id].filter(Boolean);
  await checkFreeProduct(
    threshold,
    freeProductIds,
    data.items,
    data.total_price,
  );
  await checkFreeProductWithOther(data.items);
};

const toggleCartDrawer = (forceClose = false) => {
  const cartDrawer = document.getElementById("cart-drawer");

  if (forceClose) {
    cartDrawer.classList.remove("show");
  } else {
    cartDrawer.classList.toggle("show");
  }
};

const hookUpAddToCartListeners = (classId = "body") => {
  const allAddToCartButtons = document
    .querySelector(classId)
    .querySelectorAll('[data-action="add-to-cart"]');

  allAddToCartButtons.forEach((button) => {
    if (!button.hasAttribute("data-listener-added")) {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const productId = button.getAttribute("data-product-id");
        //TODO: this does not work
        button.setAttribute("data-listener-added", "true");
        const quantityInput = document.getElementById("quantity-product");
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        const giftboxInput = document.getElementById("giftbox-input");
        const withGiftBox = giftboxInput ? giftboxInput.checked : false;
        const giftboxId = giftboxInput?.dataset.giftbox;

        // Event products: ask a name per ticket and store them as line item properties
        let properties = {};
        if (
          button.dataset.ticketNames === "true" &&
          typeof window.nonaCollectTicketNames === "function"
        ) {
          const ticketNames = await window.nonaCollectTicketNames(quantity);
          if (!ticketNames) return;
          properties = ticketNames;
        }

        if (withGiftBox) {
          addToCart(button, giftboxId, quantity, false, properties);
        } else {
          addToCart(button, productId, quantity, false, properties);
        }
      });
    }
  });
};

const hookUpDiscountFormListeners = () => {
  const form = document.querySelector(".discount-form");
  if (!form) return;

  // Toggle the input area open/closed
  const toggleBtn = form.querySelector(".discount-toggle");
  const inputArea = document.getElementById("discount-input-area");
  if (toggleBtn && inputArea) {
    // Auto-expand if there are already applied discounts
    if (inputArea.querySelectorAll(".applied-discount-tag").length > 0) {
      toggleBtn.setAttribute("aria-expanded", "true");
      inputArea.hidden = false;
    }
    toggleBtn.addEventListener("click", () => {
      const expanded = toggleBtn.getAttribute("aria-expanded") === "true";
      toggleBtn.setAttribute("aria-expanded", String(!expanded));
      inputArea.hidden = expanded;
    });
  }

  const input = document.getElementById("discount-code-input");
  const button = document.getElementById("discount-code-btn");
  const appliedList = document.getElementById("applied-discounts");
  if (!input || !button || !appliedList) return;

  const msgs = {
    applied: form.dataset.msgApplied || "Discount applied!",
    invalid: form.dataset.msgInvalid || "Code not valid or not applicable.",
    removed: form.dataset.msgRemoved || "Discount removed.",
    error: form.dataset.msgError || "Something went wrong. Please try again.",
  };

  function getUniqueDiscounts(cart) {
    // cart.discount_codes only contains manually entered codes — use it to
    // distinguish manual codes from automatic discounts reliably.
    const manualCodes = new Set(
      (cart.discount_codes || []).map((c) => c.code.toUpperCase()),
    );
    const seen = new Set();
    return (cart.discount_applications || [])
      .filter((d) => {
        if (seen.has(d.title)) return false;
        seen.add(d.title);
        return true;
      })
      .map((d) => ({
        ...d,
        isManual: manualCodes.has(d.title.toUpperCase()),
      }));
  }

  function renderDiscountTags(discounts) {
    appliedList.innerHTML = "";
    discounts.forEach((d) => {
      const isAuto = !d.isManual;
      const li = document.createElement("li");
      li.className =
        "applied-discount-tag" + (isAuto ? " applied-discount-tag--auto" : "");
      li.dataset.code = d.title;
      li.dataset.type = isAuto ? "automatic" : "discount_code";
      li.innerHTML = `<span>${d.title}</span>${isAuto ? '<span class="discount-tag-type">automatic</span>' : `<button type="button" class="remove-discount-btn" aria-label="Remove ${d.title}">&times;</button>`}`;
      if (!isAuto) {
        li.querySelector(".remove-discount-btn").addEventListener("click", () =>
          removeDiscount(d.title),
        );
      }
      appliedList.appendChild(li);
    });
  }

  async function removeDiscount(code) {
    try {
      const isSpecialCode = code.toUpperCase() === FREE_PRODUCT_DISCOUNT_CODE;
      const updatePayload = { discount: "" };

      // Clear the block and skip flag so refreshCartSections cannot re-trigger conflict detection
      // and accidentally re-set the block with stale intermediate cart data.
      localStorage.removeItem(FREE_PRODUCT_BLOCK_KEY);
      skipFreeProductCheck = true;

      if (isSpecialCode) {
        // Fetch current cart to find free/easter items to zero out in the same request
        const currentCartRes = await fetch(
          window.Shopify.routes.root + "cart.js",
        );
        const currentCart = await currentCartRes.json();
        const specialItems = currentCart.items.filter(
          (item) =>
            item.properties &&
            (item.properties._free_product === "true" ||
              item.properties._easter_product === "true"),
        );
        if (specialItems.length > 0) {
          const updates = {};
          specialItems.forEach((item) => {
            updates[item.key] = 0;
          });
          updatePayload.updates = updates;
        }
      }

      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatePayload),
      });
      await refreshCartSections();
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await cartResponse.json();
      renderDiscountTags(getUniqueDiscounts(cart));
      toast(msgs.removed, "success");
      // Re-run free product check with fresh cart data and the block definitely cleared.
      // skipFreeProductCheck prevented any stale intermediate check from re-setting the block.
      localStorage.removeItem(FREE_PRODUCT_BLOCK_KEY);
      const threshold = document.body.dataset.threshold;
      const freeProductIds = [
        document.body.dataset.freeProductId,
        document.body.dataset.freeProduct2Id,
      ].filter(Boolean);
      await checkFreeProduct(
        threshold,
        freeProductIds,
        cart.items,
        cart.total_price,
      );
    } catch (e) {
      skipFreeProductCheck = false; // ensure flag is always cleared on error
      toast(msgs.error, "error");
    }
  }

  // Hook up server-side-rendered remove buttons
  appliedList.querySelectorAll(".remove-discount-btn").forEach((btn) => {
    const code = btn.closest(".applied-discount-tag").dataset.code;
    btn.addEventListener("click", () => removeDiscount(code));
  });

  async function applyDiscount() {
    const code = input.value.trim();
    if (!code) return;

    const span = button.querySelector("span");
    const originalText = span.textContent;
    span.textContent = "...";
    button.disabled = true;

    try {
      // Codes that conflict with free products — identified by partial strings, not full codes
      const conflictingPatterns = [
        "ACB2",
        "NAPP",
        "CRONOS",
        "VAKANT",
        "VACANCE",
        "UNNONA",
        "KINGSDAY-15",
      ];
      const isConflicting = conflictingPatterns.some((p) =>
        code.toUpperCase().includes(p),
      );

      // If conflicting: block free products, remove them, then apply the discount
      if (isConflicting) {
        blockFreeProducts();
        skipFreeProductCheck = true;
        const preCartRes = await fetch(window.Shopify.routes.root + "cart.js");
        const preCart = await preCartRes.json();
        const freeItems = preCart.items.filter(
          (item) => item.properties && item.properties._free_product === "true",
        );
        if (freeItems.length > 0) {
          const updates = {};
          freeItems.forEach((item) => {
            updates[item.key] = 0;
          });
          await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        }
      }

      // GET /discount/CODE sets the discount cookie — must NOT send X-Requested-With (causes 401)
      await fetch("/discount/" + encodeURIComponent(code), {
        method: "GET",
        credentials: "include",
      });

      await refreshCartSections();

      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await cartResponse.json();
      // Check discount_codes (all accepted codes) not discount_applications
      // (which only lists codes actively reducing prices on current items).
      const applied = (cart.discount_codes || []).some(
        (d) => d.code.toUpperCase() === code.toUpperCase(),
      );

      if (applied) {
        input.value = "";
        renderDiscountTags(getUniqueDiscounts(cart));
      } else {
        toast(msgs.invalid, "error");
      }
    } catch (e) {
      toast(msgs.error, "error");
    } finally {
      span.textContent = originalText;
      button.disabled = false;
    }
  }

  button.addEventListener("click", applyDiscount);
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      applyDiscount();
    }
  });
};

hookUpAmountChangeListeners = () => {
  const allDecreaseButtons = document.querySelectorAll(
    '[data-action="decrease-quantity"]',
  );
  const allIncreaseButtons = document.querySelectorAll(
    '[data-action="increase-quantity"]',
  );

  const allRemoveFromCartButtons = document.querySelectorAll(
    '[data-action="remove-from-cart"]',
  );

  allRemoveFromCartButtons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const lineItemId = button.dataset.lineItemId;
      const giftbox = button.dataset.giftbox;
      const quantity = button.dataset.quantity;

      // Find other line items sharing the same base variant ID (before ":"),
      // e.g. a 1+1 free duplicate that Shopify creates with a different key suffix.
      const baseId = lineItemId.split(":")[0];
      const cartRes = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await cartRes.json();
      // const extraLineItemIds = cart.items
      //   .filter((item) => item.key !== lineItemId && item.key.split(":")[0] === baseId)
      //   .map((item) => item.key);
      const extraLineItemIds = [];
      removeCartItem(lineItemId, quantity, giftbox, button, extraLineItemIds);
    });
  });

  const allQuantityInputs = document.querySelectorAll("[data-line-item-id]");

  allDecreaseButtons.forEach((button) => {
    if (!button.hasAttribute("data-listener-added")) {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const input = button.nextElementSibling;
        let currentValue = parseInt(input.value, 10);

        if (input.getAttribute("min") == "1") {
          if (currentValue > 1) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event("change"));
          }
          return;
        }

        if (currentValue > 0) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event("change"));
        }
      });
      button.setAttribute("data-listener-added", "true");
    }
  });
  allIncreaseButtons.forEach((button) => {
    if (!button.hasAttribute("data-listener-added")) {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const input = button.previousElementSibling;
        let currentValue = parseInt(input.value, 10);
        input.value = currentValue + 1;
        input.dispatchEvent(new Event("change"));
      });
      button.setAttribute("data-listener-added", "true");
    }
  });

  allQuantityInputs.forEach((input) => {
    //update quantity
    let debounceTimer;

    input.addEventListener("change", async (e) => {
      clearTimeout(debounceTimer);
      input.classList.add("loading");
      debounceTimer = setTimeout(async () => {
        if (busyUpdating) return;
        busyUpdating = true;
        const lineItemId = input.dataset.lineItemId;
        if (!lineItemId) {
          // we also have quantity input on product detail page.
          // this does not need to update the cart.
          busyUpdating = false;
          return;
        }
        let updates;
        console.log(lineItemId, e.target.value);
        const launchProductId = document.body.dataset.launchProductId;
        if (
          document.body.classList.contains("offer") &&
          launchProductId &&
          lineItemId.toString().split(":")[0] === launchProductId
        ) {
          const previousCartJson = await fetch(
            window.Shopify.routes.root + "cart.js",
          );
          const previousCart = await previousCartJson.json();
          console.log("previousCart", previousCart);

          const difference =
            parseInt(e.target.value) -
            previousCart.items.find(
              (i) => i.key.toString() === lineItemId.toString(),
            ).quantity;
          console.log(difference);
          updates = {
            [lineItemId]: parseInt(e.target.value) + difference,
          };
        } else {
          updates = {
            [lineItemId]: parseInt(e.target.value),
          };
        }

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates,
            sections: [cartDrawerSectionId, nonaHeaderSectionId],
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then(async (data) => {
            busyUpdating = false;
            await updateCartJS(data);
            input.classList.remove("loading");
          })
          .catch((error) => {
            busyUpdating = false;
            input.classList.remove("loading");
            console.error("Error:", error);
          });
      }, 500);
    });
  });
};

hookUpAmountChangeListeners();
hookUpAddToCartListeners();
// const header = document.querySelector("#header-group");

// const observer = new IntersectionObserver(
//   ([entry]) => {
//     console.log("window.scrollY", window.scrollY)
//     if (entry.isIntersecting && window.scrollY === 0) {
//       header.classList.remove("sticky");
//     } else {
//       header.classList.add("sticky");
//     }
//   },
//   {
//     threshold: [0],
//   }
// );

// if (header) {
//   observer.observe(header);
// }

// window.addEventListener("scroll", () => {
//   if (header) {
//     if (header.getBoundingClientRect().top === 0 && window.scrollY === 0) {
//       header.classList.remove("sticky");
//     } else if (!header.classList.contains("sticky")) {
//       header.classList.add("sticky");
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", async function () {
  setupHeaderFunctionality();
  hookUpDiscountFormListeners();

  try {
    const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
    const cart = await cartResponse.json();
    await checkFreeProductWithOther(cart.items);
  } catch (error) {
    console.error("[FreeProductWithOther] Page-load check failed:", error);
  }

  if (window.location.hash === "#cart") {
    toggleCartDrawer();
    history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search,
    );
  }
});

const setupHeaderFunctionality = (preventHeader) => {
  const cartIcon = document.getElementById("cart-icon");
  const cartDrawer = document.getElementById("cart-drawer");
  const cartOverlay = document.querySelector(".cart-overlay");
  const closeCartButton = document.querySelector(".close-cart-button");

  cartIcon.href = "#";

  cartIcon.setAttribute("aria-haspopup", "true");
  cartIcon.setAttribute("aria-expanded", "false");
  cartDrawer.setAttribute("aria-hidden", "true");
  cartDrawer.setAttribute("role", "dialog");
  cartDrawer.addEventListener("transitionend", function () {
    if (cartDrawer.classList.contains("show")) {
      cartDrawer.setAttribute("aria-hidden", "false");
    } else {
      cartDrawer.setAttribute("aria-hidden", "true");
    }
  });

  cartOverlay.addEventListener("click", function () {
    toggleCartDrawer(true);
  });
  closeCartButton.addEventListener("click", function (event) {
    event.preventDefault();
    toggleCartDrawer(true);
  });
  if (preventHeader) {
  } else {
    cartIcon.addEventListener("click", function (event) {
      event.preventDefault();
      toggleCartDrawer();
    });
  }
};
const modal = document.getElementById("nona-modal");

modal.addEventListener("click", () => modal.close());

const myDiv = document.getElementById("inner-modal");
myDiv.addEventListener("click", (event) => event.stopPropagation());

const openNonaModal = (message) => {
  const modalBody = modal.querySelector(".nona-modal-body");
  modalBody.textContent = message;
  modal.showModal();
};

const openNonaModalWithLink = (message, linkUrl, linkText = "Learn more") => {
  const modalBody = modal.querySelector(".nona-modal-body");
  modalBody.innerHTML = "";

  const text = document.createElement("p");
  text.textContent = message;
  modalBody.appendChild(text);

  if (linkUrl) {
    const cta = document.createElement("a");
    cta.href = linkUrl;
    cta.className = "btn btn-black mt";
    cta.textContent = linkText;
    modalBody.appendChild(cta);
  }

  modal.showModal();
};

const setupPreaccessGateTriggers = () => {
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(
      "[data-preaccess-gate-trigger='true']",
    );
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const message =
      trigger.getAttribute("data-preaccess-message") ||
      "This product is currently available via pre-access only.";
    const link = trigger.getAttribute("data-preaccess-link") || "/";
    const cta = trigger.getAttribute("data-preaccess-cta") || "Get pre-access";

    openNonaModalWithLink(message, link, cta);
  });
};

setupPreaccessGateTriggers();
const setupCocktailLikeButtons = () => {
  const buttons = document.querySelectorAll(".btn-favorite-cocktail");
  buttons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const cocktailId = button.getAttribute("data-id");
      let customerId = button.getAttribute("data-customer-id");

      if (!customerId) {
        openNonaModal(window.nona.strings.cocktailsOnlyForCustomers);
        return;
      }
      console.log("Toggle favorite for cocktail:", cocktailId, customerId);
      button.classList.toggle("liked");
      const isLocalhost =
        location.hostname === "localhost" || location.hostname === "127.0.0.1";

      const apiUrl = isLocalhost
        ? `http://localhost:8080`
        : "https://nona-server-418706328134.europe-west1.run.app";

      const isFavorite = button.classList.contains("liked");
      const x = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerId,
          cocktailId,
          isFavorite,
        }),
      });

      if (!x.ok) {
        openNonaModal(window.nona.strings.somethingWentWrong);
      } else {
        toast(
          isFavorite
            ? window.nona.strings.cocktailLiked
            : window.nona.strings.cocktailUnliked,
        );
      }
    });
  });
};
setupCocktailLikeButtons();

const toast = (message, type = "info", duration = 3000) => {
  const toastElement = document.createElement("div");
  toastElement.className = `toast ${type}`;
  toastElement.textContent = message;
  document.body.appendChild(toastElement);
  setTimeout(() => {
    toastElement.remove();
  }, duration);
};

const setupShareButtons = () => {
  const buttons = document.querySelectorAll(".share-button");
  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      if (navigator.share) {
        navigator
          .share({
            title: document.title,
            url: window.location.href,
          })
          .catch((error) => {
            console.error("Error sharing:", error);
          });
      } else {
        navigator.clipboard.writeText(window.location.href).catch((err) => {
          console.error("Failed to copy:", err);
        });
        toast(window.nona.strings.copied);
      }
    });
  });
};
setupShareButtons();

const setupFilterClicks = () => {
  const filters = document.querySelectorAll(".nona-filter");
  filters.forEach((filter) => {
    filter.addEventListener("click", (event) => {
      const scrollY = window.scrollY || window.pageYOffset;
      localStorage.setItem("nona-scroll-position", scrollY);
    });
  });
};
setupFilterClicks();

const changeBundleTaste = (urlToNavigate) => {
  console.log("Navigating to:", urlToNavigate);
  const scrollY = window.scrollY || window.pageYOffset;
  localStorage.setItem("nona-scroll-position", scrollY);

  window.location.href = urlToNavigate;
};

const setupClickPreviewImages = () => {
  const previewButtons = document.querySelectorAll("[data-big-image]");
  previewButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const mainImage = document.querySelector(".main-image img");
      mainImage.classList.add("blurry");
      // set blurry small image
      mainImage.src = button.querySelector("img").src;
      mainImage.srcset = button.querySelector("img").srcset;

      const bigImageUrl = button.getAttribute("data-big-image");
      const bigImageSrcSet = button.getAttribute("data-big-image-src-set");

      mainImage.src = bigImageUrl;
      mainImage.srcset = bigImageSrcSet;

      mainImage.onload = () => {
        mainImage.classList.remove("blurry");
      };
    });
  });
};
setupClickPreviewImages();
const goToNextImage = () => {
  const mainImage = document.querySelector(".main-image img");
  const previewImages = document.querySelectorAll(".previews button");
  const currentSrc = mainImage.src;
  const currentIndex = Array.from(previewImages).findIndex((img) =>
    currentSrc.includes(img.dataset.bigImage),
  );
  const nextIndex = (currentIndex + 1) % previewImages.length;
  previewImages[nextIndex].click();
};

const goToPreviousImage = () => {
  // Left side: go to previous image
  const previewImages = document.querySelectorAll(".previews button");
  const currentSrc = mainImage.src;
  const currentIndex = Array.from(previewImages).findIndex((img) =>
    currentSrc.includes(img.dataset.bigImage),
  );
  const prevIndex =
    (currentIndex - 1 + previewImages.length) % previewImages.length;
  previewImages[prevIndex].click();
};
const mainImage = document.querySelector(".main-image img");
if (mainImage) {
  const autoscroll = false;
  if (autoscroll) {
    setInterval(() => {
      goToNextImage();
    }, 5000);
  }
  mainImage.addEventListener("click", () => {
    const rect = mainImage.getBoundingClientRect();
    const clickX = event.clientX - rect.left;

    // TODO CHECK IF WE WANT TO REMOVE ARROWS
    const arrows = document.querySelector(".main-image .scroll-buttons");
    if (arrows) {
      arrows.remove();
    }
    if (clickX < rect.width / 2) {
      goToPreviousImage();
    } else {
      // Right side: go to next image
      goToNextImage();
    }
  });
}
// DETECT IF HEADER HAS SCROLLED
const header = document.querySelector("header");
const sticky = 50;

const checkScroll = () => {
  if (window.pageYOffset > sticky) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
};
checkScroll();

window.addEventListener("scroll", checkScroll);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]',
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

const seeAllFaqsButtons = document.querySelectorAll(".see_all_faqs");

seeAllFaqsButtons.forEach((button) => {
  button.addEventListener("click", () => {
    button.nextElementSibling.classList.toggle("hide");
    button.remove();
  });
});

function getContrastColor(bgColor) {
  const rgb = bgColor.match(/\d+/g).map(Number);
  const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
  return luminance > 0.5 ? "#333" : "white";
}

// Example usage
// const el = document.querySelector(".dynamic-text");
// const bgColor = getComputedStyle(el).backgroundColor;
// el.style.color = getContrastColor(bgColor);

const allCocktailCards = document.querySelectorAll(".cocktail-card .back");
allCocktailCards.forEach((card) => {
  const bgColor = getComputedStyle(card).backgroundColor;
  card.style.color = getContrastColor(bgColor);
});

document.addEventListener("DOMContentLoaded", function () {
  const previousScrollPosition = localStorage.getItem("nona-scroll-position");
  if (previousScrollPosition) {
    window.scrollTo(0, parseInt(previousScrollPosition, 10));
    localStorage.removeItem("nona-scroll-position");
  }

  const videoBtn = document.getElementById("video-btn");
  const videoo = document.getElementById("videoo");

  if (videoBtn && videoo) {
    videoBtn.addEventListener("click", function () {
      videoo.classList.toggle("hide");
      if (!videoo.classList.contains("hide")) {
        videoo.play();
      } else {
        videoo.pause();
      }
    });
  }
});

const imageBlocks = document.querySelectorAll(".image-block:has(.image-2)");

imageBlocks.forEach((block) => {
  block.addEventListener("click", () => {
    block.classList.toggle("click");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const fadeAnimation = () => {
    const previewImages = document.querySelectorAll(".medals-block img");
    if (previewImages) {
      previewImages.forEach((img, i) => {
        setTimeout(
          () => {
            img.style.transform = "scale(1.3)";
          },
          123 * (i + 1),
        );
      });
      previewImages.forEach((img, i) => {
        setTimeout(
          () => {
            img.style.transform = "scale(1)";
          },
          123 * (i + 2),
        );
      });
    }
  };
  const uuu = document.querySelector(".medals-block");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          fadeAnimation();
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 1 },
  );
  if (uuu) {
    observer.observe(uuu);
  }
});
